import { useProcessDataContext } from '@datapeace/vms-visitor-models';
import { SharedFaceCapture } from '@datapeace/vms-visitor-screens';

export function FaceCaptureScreen() {
  const { handleCaptureFace, goBack, updateProcessData, consentConfig } =
    useProcessDataContext();
  const handleConsentChange = (_given: boolean, timestamp?: string) => {
    updateProcessData({ consentProvidedAt: timestamp ?? null });
  };
  return (
    <SharedFaceCapture
      onCapture={handleCaptureFace}
      goBack={goBack}
      consentConfig={consentConfig}
      onConsentChange={handleConsentChange}
    />
  );
}
